import { Component } from '@angular/core';

@Component({
  selector: 'ui-list-header',
  templateUrl: './list-header.component.html'
})
export class ListHeaderComponent {
}